import { useTranslation } from 'react-i18next';

import { Card } from '../../components/Card';

interface ErrorStateProps {
  onRetry: () => void;
}

export function ErrorState({ onRetry }: ErrorStateProps) {
  const { t } = useTranslation();
  return (
    <Card>
      <div className="state-icon danger" aria-hidden="true">
        !
      </div>
      <h1>{t('error.title')}</h1>
      <p>{t('error.body')}</p>
      <button type="button" className="btn-primary" onClick={onRetry}>
        {t('error.retry')}
      </button>
    </Card>
  );
}
